<script lang="ts" setup>
import { useAccessToApp } from '@autobid/ui/composables/useAccessToApp'

definePageMeta({
  layout: 'strapi',
})

const { hasAccess } = useAccessToApp()
</script>

<template>
  <SectionsAuctionCurrentPage v-if="hasAccess" />
</template>
